import React, { useState, useEffect  } from "react";
import {
  TextField,
  Button,
  Typography,
  Paper,
  Grid,
  InputAdornment,
  Modal, Box, useMediaQuery, Divider
} from '@mui/material';
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import BottomImage from "../../components/LoginPages/bottomimage";
import HeaderApp from "../../components/LoginPages/header";
import "./style.css";
import { esignToolApi } from "../../services/esignApi";
import Loader from "../../components/Loader";
import { signupUser } from "../../store/reducers/signupSlice";
import Cookies from "js-cookie";
import { companyProfile } from "../../store/reducers/profileSlice";

const SignupDetails = ({signInDetailsOpen, setSignInDetailsOpen, setLoginOpen}) => {
  const dispatch = useDispatch();
  const [email, setEmail] = useState(localStorage.getItem("email") || "");
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [helperText, setHelperText] = useState({ firstname: "", lastname: "", email: "", password: "" });
  const [errors, setErrors] = useState({ firstname: "", lastname: "", email: "", password: "" });
  const isSmallScreen = useMediaQuery(theme => theme.breakpoints.down('sm'));
  const isMediumScreen = useMediaQuery(theme => theme.breakpoints.between('sm', 'md'));
  const isLargeScreen = useMediaQuery(theme => theme.breakpoints.up('md'));
  useEffect(() => {
    setEmail(localStorage.getItem("email") || "");
  }, []);

  const validateInputs = () => {
    let newErrors = { firstname: "", lastname: "", email: "", password: "" };
    let newHelperText = { firstname: "", lastname: "", email: "", password: "" };
    let isValid = true;

    if (!firstname.trim()) {
      newErrors.firstname = "First name is required";
      newHelperText.firstname = "First name is required";
      isValid = false;
    } else if (!/^[a-zA-Z]+$/.test(firstname)) {
      newErrors.firstname = "Only alphabets are allowed";
      newHelperText.firstname = "Only alphabets are allowed";
      isValid = false;
    }

    if (!lastname.trim()) {
      newErrors.lastname = "Last name is required";
      newHelperText.lastname = "Last name is required";
      isValid = false;
    } else if (!/^[a-zA-Z]+$/.test(lastname)) {
      newErrors.lastname = "Only alphabets are allowed";
      newHelperText.lastname = "Only alphabets are allowed";
      isValid = false;
    }

    if (!email) {
      newErrors.email = "Email is required";
      isValid = false;
    }

    if (!password.trim()) {
        newErrors.password = "Password is required";
        newHelperText.password = "Password is required";
        isValid = false;
    }
    else if (password.length < 8)
    {
        newErrors.password = "Password must be atleast 8 characters.";
        newHelperText.password = "Password must be atleast 8 characters.";
        isValid = false;
    }

    setErrors(newErrors);
    setHelperText(newHelperText);
    return isValid;
  };

  const handleSubmit = async () => {
    if (validateInputs()) {
      setLoader(true)
      const curlPayload = {
        customer_name: `${firstname} ${lastname}`,
        gstno: "",
        add1: "",
        add2: "", 
        add3: "", 
        add4: "",
        state: "",
        customer_type: "indivisual",
        email: email,
        password: password,
        mobile: "",
      };
      try {
        const curlResponse = await axios.post(
          "https://invoice.meon.co.in/addcompanyoutside",
          new URLSearchParams(curlPayload),
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              Authorization:
                "Bearer 12A9F8B3C5D6E7F8G9H0J1K2L3M4N5P6Q7R8S9T0U1V2W3X4Y5Z6A7B8C9D0E1F2G3H4",
            },
          }
        );
        if (!curlResponse.data.status) {
          console.log("Failed to add company. Please try again.");
          setLoader(false);
          return;
        }
        // console.log(curlResponse,curlResponse.data.customer_id)
        const { customer_id } = curlResponse.data;

        if (!customer_id) {
          console.log("Customer ID not received. Please try again.");
          setLoader(false);
          return;
        }

        const data = {
          company_email: email,
          company_name: `${firstname} ${lastname}`,
          password: password,
          account_type: "Prepaid",
          admin_type: "user",
          esign_price: "20.00",
          customer_id: customer_id,
          credentials_type: "esign",
          is_google: false,
          visitor_id: Cookies.get("guid") || "",
        }
        try {
          const result = await dispatch(signupUser(data)).unwrap();
          console.log("Signup successful:", result);
          Cookies.set("c_d_token", result?.credentials?.token, { expires: 7, secure: true, sameSite: "Strict" });
          setSignInDetailsOpen(false);
          dispatch(companyProfile());
          // const redirectTo = location.state?.from?.pathname || "/";
          // navigate(redirectTo, { replace: true });
        } catch (error) {
          console.error("Signup failed:", error);
        }
      } catch (error) {
          setLoader(false)
          console.error("Error verifyotp:", error);
      }
    }
  };

  const handleEmailClick = () => {
    localStorage.removeItem("email");
    setEmail("");
    navigate("/signup");
  };
  
  const handlePasswordToggle = () => {
    setShowPassword((prev) => !prev);
  }
  

  return (
    <>
      <Modal open={signInDetailsOpen} onClose={() => setSignInDetailsOpen(false)} sx={{ backdropFilter: "blur(5px)", background: "#1D1D1D99"}} slotProps={{
        backdrop: {
          sx: {
            backgroundColor: "transparent",
          },
        },
      }}>
        <Box sx={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", width: isSmallScreen ? "90%" : "500px", maxHeight: "600px", backgroundColor: "#fff", boxShadow: 24, overflow: "auto", borderRadius: "20px", }}>
          <Paper elevation={3} sx={{ background:'#fffff', position: 'relative', zIndex: 1, borderRadius: "15px", boxShadow: "rgba(0, 0, 0, 0.1) 0px 7px 49px 0px" }}>
            <Box sx={{ padding: "1.6em 3em", display: 'flex', flexDirection: 'column', alignItems: 'center', }}>
              <Typography variant="h5" gutterBottom sx={{ fontWeight: 700, fontSize: '24px' }}>
                Just a bit more!
              </Typography>

              <TextField
                placeholder="First name"
                variant="outlined"
                fullWidth
                value={firstname}
                onChange={(e) => {
                  setFirstname(e.target.value)
                  setErrors((prevErrors) => ({ ...prevErrors, firstname: "" }));
                  setHelperText((prevHelperText) => ({ ...prevHelperText, firstname: "" }))
              }}
                error={!!errors.firstname}
                sx={{
                  mt: 2,
                  boxSizing: "border-box",
                  borderRadius: "10px",
                  backgroundColor: "#fff",
                  borderColor: "#C0C0C0",
                  borderWidth: "5px",
                  "& .MuiOutlinedInput-root": {
                    borderColor: errors.firstname ? "#FF6666" : "#C0C0C0",
                    backgroundColor: errors.firstname ? "#FFF1F1" : "none",
                    "&:hover fieldset": {
                      borderColor: errors.firstname ? "#FF6666" : "#C0C0C0",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: errors.firstname ? "#FF6666" : "#C0C0C0",
                    },
                  },
                  "& .MuiFormHelperText-root": {
                    color: "#FF6666",
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <img src={`${process.env.PUBLIC_URL}/images/user.svg`} alt="Email Icon" style={{ width: 18, height: 18 }} />
                    </InputAdornment>
                  ),
                  sx: { borderRadius: "10px", height: 45, fontSize: "16px", fontWeight: firstname ? "600" : "400" },
                }}
              />

              {!! errors.firstname && (
                  <Typography
                  sx={{
                      color: "#FF6666",
                      fontSize: "12px",
                      mt: 0.5,
                      mb: 0,
                      marginRight: "auto"
                  }}
                  >
                  {helperText.firstname}
                  </Typography>
              )}

              <TextField
                placeholder="Last name"
                variant="outlined"
                fullWidth
                value={lastname}
                onChange={(e) => {
                  setLastname(e.target.value)
                  setErrors((prevErrors) => ({ ...prevErrors, lastname: "" }));
                  setHelperText((prevHelperText) => ({ ...prevHelperText, lastname: "" }))
              }}
                error={!!errors.lastname}
                sx={{
                  mt: 2,
                  boxSizing: "border-box",
                  borderRadius: "10px",
                  backgroundColor: "#fff",
                  borderColor: "#C0C0C0",
                  borderWidth: "5px",
                  "& .MuiOutlinedInput-root": {
                    borderColor: errors.lastname ? "#FF6666" : "#C0C0C0",
                    backgroundColor: errors.lastname ? "#FFF1F1" : "none",
                    "&:hover fieldset": {
                      borderColor: errors.lastname ? "#FF6666" : "#C0C0C0",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: errors.lastname ? "#FF6666" : "#C0C0C0",
                    },
                  },
                  "& .MuiFormHelperText-root": {
                    color: "#FF6666",
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <img src={`${process.env.PUBLIC_URL}/images/user.svg`} alt="Email Icon" style={{ width: 18, height: 18 }} />
                    </InputAdornment>
                  ),
                  sx: { borderRadius: "10px", height: 45, fontSize: "16px", fontWeight: lastname ? "600" : "400" },
                }}
              />

              {!! errors.lastname && (
                  <Typography
                  sx={{
                      color: "#FF6666",
                      fontSize: "12px",
                      mt: 0.5,
                      mb: 0,
                      marginRight: "auto"
                  }}
                  >
                  {helperText.lastname}
                  </Typography>
              )}

              <TextField
                placeholder="Email address"
                type="email"
                variant="outlined"
                fullWidth
                value={email}
                error={!!errors.email}
                disabled
                sx={{
                  mt: 2,
                  boxSizing: "border-box",
                  borderRadius: "10px",
                  backgroundColor: "#fff",
                  borderColor: "#C0C0C0",
                  borderWidth: "5px",
                  "& .Mui-disabled": {
                    cursor: "pointer"
                  }
                }}
                InputProps={{
                  startAdornment: (
                      <InputAdornment position="start">
                          <img src={`${process.env.PUBLIC_URL}/images/mail.svg`} alt="Email Icon" style={{ width: 18, height: 18 }} />
                      </InputAdornment>
                  ),
                  endAdornment: (
                      <InputAdornment position="end">
                          <Typography onClick={handleEmailClick} sx={{ cursor: "pointer", color: "#185CB7", fontSize: "15px", fontWeight: 600, transition: "color 0.2s ease-in-out", textDecoration: "none", }}>
                              Change
                          </Typography>
                      </InputAdornment>
                  ),
                  sx: { borderRadius: "10px", height: 45, fontSize: "16px", fontWeight: email ? "600" : "400" },
                }}
              />

              <TextField
                placeholder="Password"
                type={showPassword ? "text" : "password"}
                variant="outlined"
                fullWidth
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value)
                  setErrors((prevErrors) => ({ ...prevErrors, password: "" }));
                  setHelperText((prevHelperText) => ({ ...prevHelperText, password: "" }))
              }}
                error={!!errors.password}
                sx={{
                  mt: 2,
                  boxSizing: "border-box",
                  borderRadius: "10px",
                  backgroundColor: "#fff",
                  borderColor: "#C0C0C0",
                  borderWidth: "5px",
                  "& .MuiOutlinedInput-root": {
                    borderColor: errors.password ? "#FF6666" : "#C0C0C0",
                    backgroundColor: errors.password ? "#FFF1F1" : "none",
                    "&:hover fieldset": {
                      borderColor: errors.password ? "#FF6666" : "#C0C0C0",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: errors.password ? "#FF6666" : "#C0C0C0",
                    },
                  },
                  "& .MuiFormHelperText-root": {
                    color: "#FF6666",
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <img src={`${process.env.PUBLIC_URL}/images/user.svg`} alt="Email Icon" style={{ width: 18, height: 18 }} />
                    </InputAdornment>
                  ),
                  endAdornment: (
                      <InputAdornment position="end">
                          <Typography
                              onClick={handlePasswordToggle}
                              sx={{
                                  cursor: "pointer",
                                  color: "#185CB7",
                                  fontSize: "15px",
                                  fontWeight: 600,
                                  transition: "color 0.2s ease-in-out",
                                  textDecoration: "none",
                              }}
                              >
                              {showPassword ? "Hide" : "Show"}
                          </Typography>
                      </InputAdornment>
                  ),
                  sx: { 
                      borderRadius: "10px",
                      height: 45,
                      fontSize: "16px",
                      fontWeight: password ? "600" : "400",
                      "& input::-ms-reveal, & input::-ms-clear": {
                          display: "none",
                      },
                  },
                }}
              />

              {!! errors.password && (
                  <Typography
                  sx={{
                      color: "#FF6666",
                      fontSize: "12px",
                      mt: 0.5,
                      mb: 0,
                      marginRight: "auto"
                  }}
                  >
                  {helperText.password}
                  </Typography>
              )}

              <Button
                variant="contained"
                sx={{
                  mt: 3,
                  width: '100%',
                  height: 45,
                  color: "#fff",
                  background: "#185CB7",
                  textTransform: "none",
                  fontSize: "16px",
                  borderRadius: "10px",
                  fontWeight: "600",
                  "&:hover": { background: "#185CB7" },
                }}
                onClick={handleSubmit}
              >
                Sign up
              </Button>

              <Typography sx={{fontSize: "10px", color: "#7F7F7F", my: 2, textAlign: "center"}}>This site is protected by reCAPTCHA and the <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" style={{ color: "#185CB7"}}>Google Privacy Policy</a> and <a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer" style={{ color: "#185CB7" }}>Terms of Service</a> apply.</Typography>
            </Box>
            <Divider sx={{ width: "100%" }} />
            <Box sx={{ p: "26px 0", display: 'flex', flexDirection: 'column', alignItems: 'center', }}>
              <Typography gutterBottom sx={{ fontWeight: 400, fontSize: '16px', color: '#1D1D1D', display: "flex", alignItems: "center", gap: 1, mb: 0, }}>
                  Already have an account? <span style={{ fontWeight: 600, fontSize: '16px', color: "#185CB7", cursor: "pointer" }} onClick={() => {setLoginOpen(true); setSignInDetailsOpen(false); }}>Log In</span>
              </Typography>
            </Box>
          </Paper>
        </Box>
      </Modal>
      {loader && <Loader />}
    </>
  );
};

export default SignupDetails;
